module.exports = __webpack_public_path__ + "static/img/btn1.4621787.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloads/btn1.png
// module id = +m5i
// module chunks = 0